import PropTypes from "prop-types";
import React from "react";

const SchedulerNotes = ({showDesc, title}) => {
  return (
    <span className="SchedulerNotes">
      <span
        className="erg-margin-right-5 text-scheduler"
        title={!showDesc ? title : ""}>
        <i className="fa fa-comment" />
      </span>
      {showDesc ? <span className="icon-desc">{title}</span> : null}
    </span>
  );
};

SchedulerNotes.propTypes = {
  showDesc: PropTypes.bool,
  title: PropTypes.string,
};

SchedulerNotes.defaultProps = {
  title: "Has Scheduler Notes",
};

export default SchedulerNotes;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/icons/SchedulerNotes.js
 **/